import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Chart, ArcElement, Tooltip, Legend, DoughnutController } from 'chart.js';

// Register Chart.js components
Chart.register(ArcElement, Tooltip, Legend, DoughnutController);

declare const module: {
  hot?: {
    accept(): void;
    dispose(cb: () => void): void;
  };
};

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {})
  .catch((err: any) => console.error(err));
